<template>
  <div :class="classSize"><slot /></div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * Core typography component for displaying text in a subtitle style.
 *
 * ```
 * import xSubtitle from '@/components/shared/x-subtitle'
 *
 * <x-subtitle size="1">Lorem Ipsum</x-subtitle>
 * ```
 */
export default {
  name: 'XSubtitle',
  props: {
    /**
     * Size of subtitle to display.
     * Size Options: `1, 2, 3, 4`
     */
    size: {
      type: String,
      default: '1',
      validator: function (value) {
        return ['1', '2', '3', '4'].includes(value)
      },
    },
  },
  computed: {
    classSize() {
      return 'subtitle' + this.size
    },
  },
}
</script>
